/* eslint-disable @typescript-eslint/naming-convention */

export enum AccessLevel {
  BLOCKED = 'blocked',
  COMPLETE = 'complete',
  LIMITED = 'limited',
  TRILHA1 = 'trilha-1',
  LIMITED_NACIONAL = 'limited_nacional',
  COMPLETE_NACIONAL = 'complete_nacional',
  MODULAR = 'modular'
}
